module.exports = __webpack_public_path__ + "media/PAG88-01.be1d0937.mp3";